import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
declare var $: any;
@Component({
  selector: 'app-asidebar',
  templateUrl: './asidebar.component.html',
  styleUrls: ['./asidebar.component.css'],
})
export class AsidebarComponent implements OnInit {
  user: any;
  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit() {
    this.user = this.authService.user;
  }

  toggleMenu() {
    $('#sidebar').toggleClass('active');
    $('#rotateN').toggleClass('rotate180');
    $('#sidebarCollapse').toggleClass('m10Sty');
    if (!$('#submenuOfLoanAppl').hasClass('breVis')) {
      $('#sidebar').toggleClass('newWidth');
    }
    let elem = document.getElementById('asdsadada');
    if (elem.classList.contains('disnone')) {
      setTimeout(() => {
        $('#asdsadada').toggleClass('disnone');
      }, 180);
    } else {
      $('#asdsadada').toggleClass('disnone');
    }
  }

  gotoP(v) {
    switch (v) {
      case 'profile':
        this.router.navigateByUrl('/profile');
        break;
      case 'logout':
        this.logout();
        break;
    }
  }
  logout() {
    this.authService.logout().subscribe(
      () => {
        this.router.navigateByUrl('/login');
      },
      () => {
        console.log('Cant logout :-(');
      }
    );
  }
}
